import * as React from 'react';

import { useAssessmentContext } from '../../context';
import IAssessmentElement from '../../models/IAssessmentElement';
import ISchemaItems from '../../models/ISchemaItems';
import { IValidatorConfig, IValidatorResult } from '../../models/IValidator';
import useQuestionManager from '../../plugins/useQuestionManager';
import TextField from '../inputs/TextField';

interface IProps 
{
	question: IAssessmentElement,
	onValidatorResultChanged?(validatorResult: IValidatorResult): void,
	onResetValidation?(parentElement: IAssessmentElement | null): void,
	validatorConfig?: IValidatorConfig
}

export function NumberInput(props: IProps)
{
	const assessmentContext = useAssessmentContext();
	const questionManager = useQuestionManager();
	const [answerValues, setAnswerValues] = React.useState<string[]>(assessmentContext.pageAnswers.filter(x => x.id == props.question.id)[0]?.value ?? []);
	const [schemaItems] = React.useState<ISchemaItems | null>(questionManager.getSchemaItems(props.question));

	// Sync with external updates from Redux (e.g., address lookup population)
	React.useEffect(() =>
	{
		const externalAnswers = assessmentContext.pageAnswers.filter(
			x => x.id == props.question.id
		)[0]?.value ?? [];

		setAnswerValues(externalAnswers);
	}, [assessmentContext.pageAnswers, props.question.id]);

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
	{
		const value = e.target.value
		setAnswerValues([value])
	};

	const onBlur = () =>
	{
		questionManager.updateAnswerValue(props.question.id, answerValues);

		if(props.onResetValidation && props.question.hasConditionalChildren)
			props.onResetValidation(props.question);
	};

	return <TextField
		onValidatorResultChanged={props.onValidatorResultChanged}
		validator={{
			validatorRules: questionManager.getQuestionValidatorRules(props.question),
			config: props.validatorConfig
		}}
		value={answerValues[0] ?? ''}
		answerValue={answerValues}
		onBlur={onBlur}
		onChange={onChange}
		onWheel={(event) => event.currentTarget.querySelector('input')?.blur()}
		inputProps={{
			step: 1,
			min: schemaItems?.minimum,
			max: schemaItems?.maximum,
			type: 'number'
		}} />
}

export default NumberInput;
